module.exports = __webpack_public_path__ + "static/img/49111.8ee91bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/49111.jpg
// module id = 1/M8
// module chunks = 1